import { render, staticRenderFns } from "./bindOrderUsage.vue?vue&type=template&id=c13a8e7a&scoped=true&"
import script from "./bindOrderUsage.vue?vue&type=script&lang=js&"
export * from "./bindOrderUsage.vue?vue&type=script&lang=js&"
import style0 from "./bindOrderUsage.vue?vue&type=style&index=0&id=c13a8e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a8e7a",
  null
  
)

export default component.exports